import { useMemo } from 'react';
import type { ReactNode } from 'react';
import type { TableProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { SlaTableExpandButton } from '~/app/landing/sla/shared/components/SlaTableExpandButton';

type Args<TRow> = {
  renderExpandedRow: (row: TRow) => ReactNode;
  rowExpandable?: (row: TRow) => boolean;
};

export function useSlaPartnerTableExpandable<TRow>({
  renderExpandedRow,
  rowExpandable,
}: Args<TRow>): TableProps<TRow>['expandable'] {
  const { t } = useTranslation('sla');

  return useMemo(
    () => ({
      columnWidth: 52,
      expandedRowRender: renderExpandedRow,
      rowExpandable: rowExpandable ?? (() => true),
      expandIcon: ({ expanded, expandable: canExpand, onExpand, record }) =>
        canExpand ? (
          <SlaTableExpandButton
            expanded={expanded}
            ariaLabel={
              expanded ? t('table.collapseDetails') : t('table.expandDetails')
            }
            onClick={(event) => onExpand(record, event)}
          />
        ) : null,
    }),
    [renderExpandedRow, rowExpandable, t],
  );
}
